import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/mockData';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CategoriesPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      
      <main className="flex-1">
        {/* Page Header */}
        <div className="bg-white border-b mb-6">
          <div className="max-w-7xl mx-auto px-4 py-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">All Categories</h1>
            <p className="text-gray-600 mt-2">Browse deals by category</p>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="max-w-7xl mx-auto px-4 pb-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="bg-white border border-gray-200 rounded-lg py-6 px-6 text-center hover:shadow-lg hover:border-[#E53A7F] transition-all duration-200 group"
              >
                <span className="text-gray-700 font-medium text-lg group-hover:text-[#E53A7F] transition-colors">
                  {category.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CategoriesPage;
